module.exports = __webpack_public_path__ + "img/scan-serial-sim-2.7d48a792.png";